module.exports = __webpack_public_path__ + "img/arrow-check-primary-icon.a1e2e4a.svg";